export const claudeConstants = {
  LAUNCH_REQUEST: 'CLAUDE_LAUNCH_REQUEST',
  LAUNCH_SUCCESS: 'CLAUDE_LAUNCH_SUCCESS',
  LAUNCH_FAILURE: 'CLAUDE_LAUNCH_FAILURE',

  STATUS_REQUEST: 'CLAUDE_STATUS_REQUEST',
  STATUS_SUCCESS: 'CLAUDE_STATUS_SUCCESS',
  STATUS_FAILURE: 'CLAUDE_STATUS_FAILURE',

  HISTORY_REQUEST: 'CLAUDE_HISTORY_REQUEST',
  HISTORY_SUCCESS: 'CLAUDE_HISTORY_SUCCESS',
  HISTORY_FAILURE: 'CLAUDE_HISTORY_FAILURE',

  LOGS_REQUEST: 'CLAUDE_LOGS_REQUEST',
  LOGS_SUCCESS: 'CLAUDE_LOGS_SUCCESS',
  LOGS_FAILURE: 'CLAUDE_LOGS_FAILURE',

  LOG_REQUEST: 'CLAUDE_LOG_REQUEST',
  LOG_SUCCESS: 'CLAUDE_LOG_SUCCESS',
  LOG_FAILURE: 'CLAUDE_LOG_FAILURE',

  CANCEL_REQUEST: 'CLAUDE_CANCEL_REQUEST',
  CANCEL_SUCCESS: 'CLAUDE_CANCEL_SUCCESS',
  CANCEL_FAILURE: 'CLAUDE_CANCEL_FAILURE',

  CANCEL_BATCH_REQUEST: 'CLAUDE_CANCEL_BATCH_REQUEST',
  CANCEL_BATCH_SUCCESS: 'CLAUDE_CANCEL_BATCH_SUCCESS',
  CANCEL_BATCH_FAILURE: 'CLAUDE_CANCEL_BATCH_FAILURE',

  RETRY_REQUEST: 'CLAUDE_RETRY_REQUEST',
  RETRY_SUCCESS: 'CLAUDE_RETRY_SUCCESS',
  RETRY_FAILURE: 'CLAUDE_RETRY_FAILURE',

  RETRY_BATCH_REQUEST: 'CLAUDE_RETRY_BATCH_REQUEST',
  RETRY_BATCH_SUCCESS: 'CLAUDE_RETRY_BATCH_SUCCESS',
  RETRY_BATCH_FAILURE: 'CLAUDE_RETRY_BATCH_FAILURE',

  DELETE_REQUEST: 'CLAUDE_DELETE_REQUEST',
  DELETE_SUCCESS: 'CLAUDE_DELETE_SUCCESS',
  DELETE_FAILURE: 'CLAUDE_DELETE_FAILURE',

  DELETE_BATCH_REQUEST: 'CLAUDE_DELETE_BATCH_REQUEST',
  DELETE_BATCH_SUCCESS: 'CLAUDE_DELETE_BATCH_SUCCESS',
  DELETE_BATCH_FAILURE: 'CLAUDE_DELETE_BATCH_FAILURE',
};